import { TRefinanceableDebt } from '@axo/form/feature/axo-form-v1/components/ExtendedLoanOverview/context/ExtendedLoanOverviewContext/ExtendedLoanOverviewContext.types';

type GetTotalRefinanceAmountParams = {
  refinanceableDebts: TRefinanceableDebt[];
};

export const getTotalRefinanceAmount = ({
  refinanceableDebts,
}: GetTotalRefinanceAmountParams) =>
  refinanceableDebts.reduce(
    (acc, debt) => (debt.isChecked ? acc + debt.value : acc),
    0
  );
